import {STORE_USERS} from '../constants'

export function storeUser(apiResponse) {
  return {type: STORE_USERS, users: [apiResponse]}
}

export function storeUsers(apiResponse) {
  return {type: STORE_USERS, users: apiResponse}
}
